import { snakeToCamel } from '../../../utils/object'

import Model from '../models'

import ApplicationReportAPI from './api'

export default class ApplicationReport extends Model {
  static api = ApplicationReportAPI.create(ApplicationReport)
  static readOnlyFields = ['id', 'application']

  constructor({
    id = null,
    application = null,
    applicationRef = null,
    evaluationRefs = [],
    commitmentRefs = [],
    files = [],
    fileRefs = [],
    published = false,
    universalFeedback = '',
  } = {}) {
    super()
    Object.assign(this, {
      id,
      application,
      applicationRef,
      evaluationRefs,
      commitmentRefs,
      files,
      fileRefs,
      published,
      universalFeedback,
    })
  }

  static create(opts = {}) {
    return new ApplicationReport(opts)
  }

  static fromAPI(json = {}) {
    return new ApplicationReport(snakeToCamel(json))
  }

  copy() {
    return new ApplicationReport(this)
  }
}
